import React from "react"

const Piezometer = ({ item }) => {
    return (
        <div className={`border-black border-2 w-8 h-8 ${item.name === "PZ" ? "rounded-full" : "rounded-sm"}`}>
            <div
                className={
                `${item.status === "online" ? 
                    "from-green-700 via-green-400 to-green-200 bg-gradient-to-tr" : 
                    item.status === "offline" ?
                        "from-red-700 via-red-400 to-red-200 bg-gradient-to-tr" : 
                        "from-orange-400 via-orange-400 to-orange-200 bg-gradient-to-tr"
                } 
                w-full h-full 
                ${item.name === "PZ" ? 
                    "rounded-full" : 
                    "rounded-xs"
                } mx-auto flex items-center`
            }>
                <p className="text-white mx-auto my-auto text-xs">
                    {item.name}
                </p>
            </div>
        </div>
    )
}

export default Piezometer;